exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-066bf88e] .el-card__body{height:100%}[data-v-066bf88e] .el-icon-arrow-right{display:none}[data-v-066bf88e] .el-badge__content{top:10px}", ""]);

// exports
